<template>
  <div class="modalShares">
    <div style="border-radius:10px;padding:10px;" class="card">
      <img
        @click="closeModalExporterColidee()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
      <p>{{ $t("sondage.exporter_colidee") }}</p>
      <hr />
      <b-message size="is-small" type="is-info" has-icon>{{
        $t("sondage.explication_colidee")
      }}</b-message>
      <div>
        <label style="float:left">{{
          $t("sondage.label_code_participant")
        }}</label>
        <input
          type="text"
          class="input"
          :value="modalExportColidee.sondageUrlClient"
        />
      </div>
      <div>
        <label style="float:left">{{ $t("sondage.label_code_reponse") }}</label>
        <textarea
          class="textarea"
          type="textarea"
          :value="modalExportColidee.sondageUrlModerateur"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalExportColidee',
  props: {
    modalExportColidee: Object
  },
  methods: {
    closeModalExporterColidee () {
      this.$store.commit('MODAL_EXPORTCOLIDEE', false)
    }
  }
}
</script>
<style scoped>
.modalShares {
  font-size:12px;
  margin:50px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.input::placeholder {
  color: grey;
}
.textarea {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.textarea::placeholder {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/sondage/components/ModalExportColidee.vue